module.exports = __webpack_public_path__ + "static/media/ic-three-dots-blue.6b374329.svg";